/* eslint-disable max-lines */
import { type TranslationDataObj } from './type';

export const data: TranslationDataObj = {
  'components.product-template-editor.product-template-page': {
    newTemplateTitle: {
      en: 'New Template',
      fr: 'Nouveau modèle',
    },
    editTemplateTitle: {
      en: 'Edit Template',
      fr: 'Modifier le modèle',
    },
    warningModalTitle: {
      en: 'These changes will apply to all existing products using this template. Continue?',
      fr: 'Ces modifications seront appliquées à tous les produits existants utilisant ce modèle. Continuer ?',
    },
  },
  'components.product-template-editor.product-template-editor': {
    createNewTemplate: {
      en: 'Create new template',
      fr: 'Créer un nouveau modèle',
    },
    editTemplate: {
      en: 'Edit template',
      fr: 'Modifier le modèle',
    },
    addAnotherExample: {
      en: 'Add another example',
      fr: 'Ajouter un autre exemple',
    },
    subTitle: {
      en: 'Define key fields for your CMS or product pages with clear, specific guidance. The more context you provide, the better the AI can generate high-quality, relevant, and unique content.',
      fr: `Définissez les champs clés de votre CMS ou pages produits avec des instructions claires et spécifiques. Plus vous fournissez de contexte, mieux l'IA peut générer du contenu de qualité, pertinent et unique.`,
    },
    generalPageInformation: {
      en: 'General page information',
      fr: 'Informations générales de la page',
    },
    templateNameLabel: {
      en: 'Template name',
      fr: 'Nom du modèle',
    },
    templateNamePlaceholder: {
      en: 'Name your page structure...',
      fr: 'Nommez votre structure de page...',
    },
    templateAdditionalInformationLabel: {
      en: 'Additional information (optional)',
      fr: 'Informations supplémentaires (optionnel)',
    },
    templateAdditionalInformationPlaceholder: {
      en: 'Add guidelines for content generation (e.g., "Focus on texture and scent for beauty products", "Emphasize fit and fabric feel for fashion items")',
      fr: `Ajoutez des directives pour la génération de contenu (ex. : "Concentrez-vous sur la texture et le parfum pour les produits de beauté", "Mettez l'accent sur la coupe et le toucher du tissu pour les articles de mode")`,
    },
    pageSections: {
      en: 'Page sections',
      fr: 'Sections de la page',
    },
    addNewField: {
      en: 'Add new field',
      fr: 'Ajouter un nouveau champ',
    },
    addAnotherSection: {
      en: 'Add another section',
      fr: 'Ajouter une autre section',
    },
    sectionTitle: {
      en: 'Section title',
      fr: 'Titre de la section',
    },
    sectionTitlePlaceholder: {
      en: 'Name your section...',
      fr: 'Nommez votre section...',
    },
    sectionDescription: {
      en: 'Description',
      fr: 'Description',
    },
    sectionDescriptionPlaceholder: {
      en: 'Add instructions...',
      fr: 'Ajoutez des instructions...',
    },
    allowHeadingsStructure: {
      en: 'Allow headings structure',
      fr: 'Autoriser la structure de titres',
    },
    allowHeadingsStructureDescription: {
      en: 'Enable H1, H2, H3 headings in this field',
      fr: 'Activer les titres H1, H2, H3 dans ce champ',
    },
    allowListsStructure: {
      en: 'Allow lists structure',
      fr: 'Autoriser la structure de listes',
    },
    allowListsStructureDescription: {
      en: 'Enable bullet points and numbered lists',
      fr: 'Activer les puces et listes numérotées',
    },
    attributeField: {
      en: 'Attribute field',
      fr: "Champ d'attribut",
    },
    attributeFieldDescription: {
      en: 'Product information that will be filled after the content has been generated, such as tags',
      fr: 'Informations produit qui seront remplies après la génération du contenu, comme les tags',
    },
    contentStructureOptions: {
      en: 'Content structure options',
      fr: 'Options de structure du contenu',
    },
    examples: {
      en: 'Examples',
      fr: 'Exemples',
    },
    examplesPlaceholder: {
      en: 'Paste examples to help AI understand the expected format and style for this field...',
      fr: `Collez des exemples pour aider l'IA à comprendre le format et le style attendus pour ce champ...`,
    },
    csvExportColumnName: {
      en: 'CSV export column name',
      fr: `Nom de colonne pour l'export CSV`,
    },
    csvExportColumnNamePlaceholder: {
      en: 'Enter a custom name for this field as it should appear in the exported CSV',
      fr: `Saisissez un nom personnalisé pour ce champ tel qu'il doit apparaître dans le CSV exporté`,
    },
    unableToCreateNewTemplate: {
      en: 'Unable to create new template',
      fr: 'Impossible de créer un nouveau modèle',
    },
    unableToSaveTemplate: {
      en: 'Unable to save template',
      fr: `Impossible d'enregistrer le modèle`,
    },
    maxNumberOfWords: {
      en: 'Max number of words',
      fr: 'Nombre maximum de mots',
    },
    maxNumberOfWordsPlaceholder: {
      en: 'Max number of words for this section',
      fr: 'Nombre maximum de mots pour cette section',
    },
    useBrandContext: {
      en: 'Use brand context',
      fr: 'Utiliser le brand context',
    },
    useBrandContextDescription: {
      en: 'Apply your brand guidelines to generated content',
      fr: 'Appliquez vos directives de marque au contenu généré',
    },
    useVoiceExamples: {
      en: 'Use voice examples',
      fr: 'Utiliser des exemples de voix',
    },
    useVoiceExamplesDescription: {
      en: `Use your saved voice examples to guide the AI's tone and style`,
      fr: `Utilisez vos exemples de voix sauvegardés pour guider le ton et le style de l'IA`,
    },
    updateSuccess: {
      en: 'Product template has been updated',
      fr: 'Le modèle de produit a été mis à jour',
    },
    createSuccess: {
      en: 'Product template is created',
      fr: 'Le modèle de produit a été créé',
    },
    needAtLeastOneSection: {
      en: 'You need at least one section',
      fr: 'Vous devez avoir au moins une section',
    },
    warningModalTitle: {
      en: 'Add another section to the template?',
      fr: 'Ajouter une autre section au modèle ?',
    },
    warningModalDescription: {
      en: 'This section will also be added to all existing products created using this template. It will appear as blank in those products until filled in.',
      fr: 'Cette section sera également ajoutée à tous les produits existants créés à l’aide de ce modèle. Elle apparaîtra comme vide dans ces produits jusqu’à ce qu’elle soit remplie.',
    },
    addSection: {
      en: 'Add section',
      fr: 'Ajouter une section',
    },
  },
  'components.product-template-editor.template-preview': {
    instructions: {
      en: 'Instructions',
      fr: 'Instructions',
    },
    templatePreview: {
      en: 'Template preview',
      fr: 'Aperçu du modèle',
    },
    templatePreviewDescription: {
      en: 'This is a preview of template: {{template}}',
      fr: 'Ceci est un aperçu du modèle : {{template}}',
    },
    characterLimit: {
      en: 'Character limit',
      fr: 'Limite de caractères',
    },
  },
  'components.product-template-editor.template-cards': {
    templateDuplicated: {
      en: 'Template duplicated',
      fr: 'Modèle dupliqué',
    },
  },
  'components.product-template-editor.confirm-template-deletion': {
    confirmation: {
      en: 'Are you sure you want to delete this template?',
      fr: 'Êtes-vous sûr de vouloir supprimer ce modèle ?',
    },
    dialogDescription: {
      en: 'Please confirm if you want to delete this template',
      fr: 'Veuillez confirmer si vous souhaitez supprimer ce modèle',
    },
  },
  'components.product-template-editor.confirm-section-removal': {
    title: {
      en: 'Delete “{{sectionTitle}}” from the template?',
      fr: 'Supprimer la section “{{sectionTitle}}” du template ?',
    },
    deleteSection: {
      en: 'Delete section',
      fr: 'Supprimer la section',
    },
    dialogDescription: {
      en: 'This section will also be <strong>permanently removed from all existing products</strong> created using this template.<strong>This action cannot be undone.</strong>',
      fr: 'Cette section sera également <strong>supprimée de tous les produits existants</strong> créés à l’aide de ce modèle.<strong>Cette action ne peut pas être annulée.</strong>',
    },
  },
  'components.product-template-editor.create-new-button': {
    createNewTemplate: {
      en: 'Create new template',
      fr: 'Créer un nouveau modèle',
    },
  },
  'components.editor.editor-section-header': {
    characterLimit: {
      en: 'Character limit',
      fr: 'Limite de caractères',
    },
  },
  'components.editor.sidebar': {
    productInformation: {
      en: 'Product information',
      fr: 'Informations produit',
    },
    productStatus: {
      en: 'Product Status',
      fr: 'Statut du produit',
    },
    productImages: {
      en: 'Product Images',
      fr: 'Images du produit',
    },
    csvInformation: {
      en: 'CSV Information',
      fr: 'Informations CSV',
    },
    csvInformationEmpty: {
      en: 'Unable to retrieve initial data',
      fr: 'Impossible de récupérer les données initiales',
    },
  },
  'components.editor.product-status-selector': {
    unread: {
      en: 'Unread',
      fr: 'Non lu',
    },
    read: {
      en: 'Read',
      fr: 'Lu',
    },
    toReview: {
      en: 'To review',
      fr: 'À examiner',
    },
    approved: {
      en: 'Approved',
      fr: 'Approuvé',
    },
  },
  'components.editor.editor-section': {
    youCanReuseYourPrompt: {
      en: 'You can reuse your prompt in the future',
      fr: `Vous pourrez réutiliser votre prompt à l'avenir`,
    },
    savePrompt: {
      en: 'Save prompt',
      fr: 'Enregistrer la requête',
    },
    charactersCount: {
      en: '{{count}} characters',
      fr: '{{count}} caractères',
    },
    wordsExceeded: {
      en: 'words (exceeds limit)',
      fr: 'mots (dépasse la limite)',
    },
    copiedToClipboard: {
      en: 'Copied to clipboard',
      fr: 'Copié dans le presse-papiers',
    },
  },
  'components.editor.add-prompt': {
    title: {
      en: 'Custom prompt',
      fr: 'Requête personnalisée',
    },
    name: {
      en: 'Name',
      fr: 'Nom',
    },
    namePlaceholder: {
      en: 'e.g. Shorten text',
      fr: 'ex. Raccourcir le texte',
    },
    prompt: {
      en: 'Prompt',
      fr: 'Requête',
    },
    promptPlaceholder: {
      en: 'e.g. Shorten the text',
      fr: 'ex. Raccourcir le texte',
    },
    shareWithOrg: {
      en: 'Make public for organization',
      fr: `Rendre public pour l'organisation`,
    },
  },
  'components.editor.ai-assistant-dialogs': {
    confirmDeletion: {
      en: 'Confirm deletion',
      fr: 'Confirmer la suppression',
    },
    confirmationMessage: {
      en: 'Are you sure you want to delete',
      fr: 'Êtes-vous sûr de vouloir supprimer',
    },
  },
  'components.editor.element-selector-dropdown': {
    paragraph: {
      en: 'Paragraph',
      fr: 'Paragraphe',
    },
    heading1: {
      en: 'Heading 1',
      fr: 'Titre 1',
    },
    heading2: {
      en: 'Heading 2',
      fr: 'Titre 2',
    },
    heading3: {
      en: 'Heading 3',
      fr: 'Titre 3',
    },
    heading4: {
      en: 'Heading 4',
      fr: 'Titre 4',
    },
    triggerTooltip: {
      en: 'Text type',
      fr: 'Type de texte',
    },
    codeBlock: {
      en: 'Code block',
      fr: 'Bloc de code',
    },
    quoteBlock: {
      en: 'Quote block',
      fr: 'Bloc de citation',
    },
  },
  'components.editor.text-align-dropdown': {
    textAlignment: {
      en: 'Text alignment',
      fr: 'Alignement du texte',
    },
    alignLeft: {
      en: 'Left align',
      fr: 'Aligner à gauche',
    },
    alignCenter: {
      en: 'Center align',
      fr: 'Centrer',
    },
    alignRight: {
      en: 'Right align',
      fr: 'Aligner à droite',
    },
    justifyText: {
      en: 'Justify',
      fr: 'Justifier',
    },
  },
  'components.editor.ai-assistant': {
    aiIsWritingYourContent: {
      en: 'AI is writing your content...',
      fr: `L'IA rédige votre contenu...`,
    },
    tellAIWhatToRefine: {
      en: 'Tell {{name}} what to refine in the generated text',
      fr: `Indiquez à l'{{name}} ce qu'il faut affiner dans le texte généré`,
    },
    submitPrompt: {
      en: 'Submit prompt',
      fr: 'Soumettre la requête',
    },
    replaceSelection: {
      en: 'Replace selection',
      fr: 'Remplacer la sélection',
    },
    insertBelow: {
      en: 'Insert below',
      fr: 'Insérer en dessous',
    },
    refineAnswer: {
      en: 'Refine answer',
      fr: 'Affiner la réponse',
    },
    refineYourAnswer: {
      en: 'Refine your answer',
      fr: 'Affinez votre réponse',
    },
    regenerate: {
      en: 'Regenerate',
      fr: 'Régénérer',
    },
    tellAIWhatToGenerate: {
      en: 'Tell AI what to edit or generate',
      fr: `Indiquez à l'IA quoi éditer ou générer`,
    },
    useBrandAttributes: {
      en: 'Use brand attributes',
      fr: 'Utiliser les attributs de marque',
    },
    useSERPAnalysis: {
      en: 'Use SERP Analysis',
      fr: `Utiliser l'analyse SERP`,
    },
    editOrReviewSelection: {
      en: 'Edit or review selection',
      fr: 'Éditer ou réviser la sélection',
    },
    improveWriting: {
      en: 'Improve writing',
      fr: `Améliorer l'écriture`,
    },
    makeLonger: {
      en: 'Make longer',
      fr: 'Allonger le texte',
    },
    makeShorter: {
      en: 'Make shorter',
      fr: 'Raccourcir le texte',
    },
    changeToneTo: {
      en: 'Change tone to {{tone}}',
      fr: 'Changer le ton pour {{tone}}',
    },
    toneOfVoice: {
      en: 'Tone of voice',
      fr: 'Ton',
    },
    formal: {
      en: 'Formal',
      fr: 'Formel',
    },
    casual: {
      en: 'Casual',
      fr: 'Décontracté',
    },
    confident: {
      en: 'Confident',
      fr: 'Assuré',
    },
    humorous: {
      en: 'Humorous',
      fr: 'Humoristique',
    },
    persuasive: {
      en: 'Persuasive',
      fr: 'Persuasif',
    },
    empathetic: {
      en: 'Empathetic',
      fr: 'Empathique',
    },
    inquisitive: {
      en: 'Inquisitive',
      fr: 'Curieux',
    },
    checkGrammar: {
      en: 'Check grammar',
      fr: 'Vérifier la grammaire',
    },
    customPrompts: {
      en: 'Custom prompts',
      fr: 'Requêtes personnalisées',
    },
    createPrompt: {
      en: 'Create prompt',
      fr: 'Créer une requête',
    },
    enterInstructions: {
      en: 'Type your instructions - {{ name }} will handle it',
      fr: `Saisissez vos instructions - {{ name }} s'en occupera`,
    },
  },
  'components.editor.table-dropdown': {
    table: {
      en: 'Table',
      fr: 'Tableau',
    },
  },
  'components.editor.rich-text-editor-toolbar': {
    bold: {
      en: 'Bold',
      fr: 'Gras',
    },
    italic: {
      en: 'Italic',
      fr: 'Italique',
    },
    underline: {
      en: 'Underline',
      fr: 'Souligné',
    },
    strike: {
      en: 'Strikethrough',
      fr: 'Barré',
    },
    orderedList: {
      en: 'Ordered list',
      fr: 'Liste numérotée',
    },
    unorderedList: {
      en: 'Unordered list',
      fr: 'Liste à puces',
    },
    break: {
      en: 'Line break',
      fr: 'Saut de ligne',
    },
    link: {
      en: 'Link',
      fr: 'Lien',
    },
    image: {
      en: 'Image',
      fr: 'Image',
    },
    undo: {
      en: 'Undo',
      fr: 'Annuler',
    },
    redo: {
      en: 'Redo',
      fr: 'Rétablir',
    },
  },
  'components.general-rating': {
    good: {
      en: 'Very good',
      fr: 'Très bien',
    },
    bad: {
      en: 'Very bad',
      fr: 'Très mauvais',
    },
  },
  'components.rating-dialog': {
    title: {
      en: 'Thank you,\nyour input shapes what we create',
      fr: 'Merci,\nvos retours façonnent ce que nous créons',
    },
    subtitle: {
      en: 'Just a few more rating to guide the AI',
      fr: "Quelques évaluations supplémentaires pour guider l'IA",
    },
    infoQuality: {
      en: 'Quality of information',
      fr: "Qualité de l'information",
    },
    structureQuality: {
      en: 'Outline structure quality',
      fr: 'Qualité de la structure',
    },
    toneVoice: {
      en: 'Tone of voice',
      fr: 'Ton',
    },
    additionalCommentsLabel: {
      en: 'Additional comments (Optional)',
      fr: 'Commentaires supplémentaires (Optionnel)',
    },
    additionalCommentsPlaceholder: {
      en: 'Your feedback...',
      fr: 'Vos commentaires...',
    },
    skip: {
      en: 'Skip',
      fr: 'Passer',
    },
    send: {
      en: 'Send',
      fr: 'Envoyer',
    },
    errorRequired: {
      en: 'At least one rating is required for each category',
      fr: 'Au moins une étoile est requise pour chaque catégorie',
    },
  },
  'components.calendar-picker': {
    weekdayShortMonday: {
      en: 'Mon',
      fr: 'Lun.',
    },
    weekdayShortTuesday: {
      en: 'Tue',
      fr: 'Mar.',
    },
    weekdayShortWednesday: {
      en: 'Wed',
      fr: 'Mer.',
    },
    weekdayShortThursday: {
      en: 'Thu',
      fr: 'Jeu.',
    },
    weekdayShortFriday: {
      en: 'Fri',
      fr: 'Ven.',
    },
    weekdayShortSaturday: {
      en: 'Sat',
      fr: 'Sam.',
    },
    weekdayShortSunday: {
      en: 'Sun',
      fr: 'Dim.',
    },
  },
  'components.limit-block': {
    upgrade: {
      en: 'Upgrade',
      fr: 'Mettre à niveau',
    },
    percentUsed: {
      en: '{{percentage}}% used',
      fr: '{{percentage}}% utilisé',
    },
    unlimited: {
      en: 'Unlimited',
      fr: 'Illimités',
    },
  },
};
